import { GoogleTagManagerService } from './../../../services/analytics/google-tag-manager.service';
import { Component, Inject, OnDestroy, OnInit, ViewChild, ViewChildren, QueryList, HostListener } from '@angular/core';
import { MD_DIALOG_DATA, MdDialogRef } from '@angular/material';

import $ from 'jquery';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { ProductNearByDTO } from 'app/model/products/product-nearby-dto.model';
import { ProductService } from 'app/services/products/product.service';
import { Subscription } from 'rxjs/Subscription';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import platform from 'platform';
import { ActInfoMarker } from '../../../utilities/act-map/directives/info-marker';
import { InfoWindowContentComponent } from '../dialog-map-nearby/info-window-content/info-window-content.component';
import { ProductReviewModel } from '../../../model/products/product-review.model';
import { UserService } from '../../../services/user/user.service';
import { SearchFormModel } from '../../../model/search-form-model';
import { DefaultValue, Page } from 'app/model/constant';
import { HotelListRequest, CheapestRoom } from '../../../model/products/hotel/hotel.model';
import { Currency } from 'app/model/currency.model';
import { CurrencyService } from 'app/services/currency/currency.service';

@Component({
  selector: 'act-dialog-map-poi',
  templateUrl: './dialog-map-poi.component.html',
  styleUrls: ['./dialog-map-poi.component.scss']
})
export class DialogMapPoiComponent implements OnInit, OnDestroy {
  reviewRating: ProductReviewModel;
  public currency: Currency;

  private isMobile: boolean = false; // tslint:disable-line
  private resetCenter: boolean = false; // tslint:disable-line
  private infoWindowKey: any;
  private $mapElement: any;
  private $infoWindowElement: any;
  private productPoiList: any[];
  private isAllPopOverComplete = false;
  private countPopOver = 0;
  private countMarker = 0;
  private zoom = 0;
  private product: ProductNearByDTO;
  private gaSent = false;
  private now = new Date().getTime() / 1000;
  private radius = DefaultValue.DISTANCE;

  private getProductPoiSubScription: Subscription;
  private currencySubscription: Subscription;

  @ViewChild(InfoWindowContentComponent)
  private InfoWindowContentComponent: InfoWindowContentComponent;

  @ViewChildren(ActInfoMarker)
  private infoMarker: QueryList<ActInfoMarker>;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: {
      product: any;
      searchData: SearchFormModel;
      page: Page;
      productDistance: number;
      hotelListRequest: HotelListRequest
    },
    public dialogRef: MdDialogRef<DialogMapPoiComponent>,
    private productService: ProductService,
    private utilitiesService: UtilitiesService,
    private appConfigService: AppConfigService,
    private userService: UserService,
    private googleTagManagerService: GoogleTagManagerService,
    private currencyService: CurrencyService,
  ) {

  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    document.documentElement.style.setProperty('--dialog-vh', `${window.innerHeight * 0.01}px`);
  }

  ngOnInit() {
    this.onResize();
    if (this.data && this.data.product) {
      if (this.data.product.reviewRatingScore) {
        this.reviewRating = new ProductReviewModel(
          '' + this.data.product.reviewRatingScore,
          this.productService.calculateReviewRatingTitle(this.data.product.reviewRatingScore)
        );
      }
      this.product = this.data.product;
    }
    this.product && this.getProductPOI();
    this.utilitiesService.isMobile() && (this.isMobile = true);
    this.googleTagManagerService.emitEvent(
      'Poi Map Search',
      'Loading',
      this.data && this.data.product ? this.data.product.title || '' : '',
      0
    );

    this.subscribeCurrency();
  }

  ngOnDestroy() {
    this.getProductPoiSubScription && this.getProductPoiSubScription.unsubscribe();
    this.currencySubscription && this.currencySubscription.unsubscribe();
    this.utilitiesService.unlockBody();
    this.utilitiesService.unlockBodyBackdrop();
  }

  setInfoWindowData(image: String, title: String, rating: Number, keyMarker: String, review: ProductReviewModel, displayNavigate = false) {
    this.infoWindowKey = {
      key: keyMarker
    };
    this.InfoWindowContentComponent.setData(image, title, rating, review, true, displayNavigate);

  }

  getProductPOI() {
    this.getProductPoiSubScription && this.getProductPoiSubScription.unsubscribe();
    this.data.hotelListRequest.filterRequest.distance = this.data.searchData.radius;
    this.getProductPoiSubScription = this.productService.getProductListWithPOI(this.data.hotelListRequest).subscribe(res => {
      this.getProductPOIList(res.items);
    });
  }

  getProductPOIList(poiList: CheapestRoom[]) {
    this.productPoiList = new Array();
    let tmpDistanceLat = 0;
    let tmpDistanceLon = 0;
    const centerLon = Number(this.data.searchData.destination.poi.lon);
    const centerLat = Number(this.data.searchData.destination.poi.lat);
    let distanceLat = Math.abs(Number(this.product.latitude) - centerLat);
    let distanceLon = Math.abs(Number(this.product.longitude) - centerLon);
    poiList.forEach(element => {
      if (this.product.productId !== element.productId) {
        const productPoi = {
          'destinationId': element.destinationId,
          'distance': element.distance,
          'distanceUnit': 'Meters',
          'imageUrl': element.imageUrl,
          'latitude': element.latitude,
          'longitude': element.longitude,
          'netPrice': element.netPrice,
          'productId': element.productId,
          'hotelStar': element.hotelStar,
          'slug': element.slug,
          'suggestCat': this.data.searchData.destination.suggestCat,
          'productTitle': element.productTitle,
          'reviewRating': new ProductReviewModel('' + element.reviewRatingScore, this.productService.calculateReviewRatingTitle(element.reviewRatingScore))
        };
        this.productPoiList.push(productPoi);
      }
      tmpDistanceLat = Math.abs(element.latitude - centerLat);
      tmpDistanceLon = Math.abs(element.longitude - centerLon);
      distanceLat = tmpDistanceLat > distanceLat ? tmpDistanceLat : distanceLat;
      distanceLon = tmpDistanceLon > distanceLon ? tmpDistanceLon : distanceLon;

    });
    const mapElement = <HTMLElement>document.querySelector('.dialog-map');
    const widthPixel = this.isMobile ? mapElement.offsetWidth / 3.5 : 256;
    const heightPixel = this.isMobile ? mapElement.offsetHeight / 4.2 : 148;
    const GLOBE_WIDTH = 256;
    const zoomLat = Math.round(Math.log(heightPixel * 360 / distanceLat / GLOBE_WIDTH) / Math.LN2);
    const zoomLon = Math.round(Math.log(widthPixel * 360 / distanceLon / GLOBE_WIDTH) / Math.LN2);
    this.zoom = zoomLat < zoomLon ? zoomLat : zoomLon;
    if (poiList.length > 0) {
      let maxDistance = Math.max.apply(Math, poiList.map(o => { return o.distance; }));
      let tempRadius = Math.round((maxDistance * 1.01) / Math.LN2);
      this.radius = tempRadius > this.data.searchData.radius ? this.data.searchData.radius : tempRadius;
    } else {
      let tempRadius = Math.round((this.data.product.distance * 1.01) / Math.LN2);
      this.radius = tempRadius > this.data.searchData.radius ? this.data.searchData.radius : tempRadius;
    }
  }

  onMarkerClicked(data) {
    const key = data && data.key ? data.key : undefined;
    this.isMobile && key && this.setActiveMarker(key);
    switch (key) {
      case undefined:
        break;
      case `center`:
        this.setInfoWindowData(
          this.data.product.imageUrl,
          this.data.product.productTitle,
          this.data.product.hotelStar,
          key,
          this.reviewRating,
          true
        );
        break;
      default:
        const product = this.productPoiList[key];
        this.setInfoWindowData(
          product.imageUrl,
          product.productTitle,
          product.hotelStar,
          data.key,
          product.reviewRating
        );
        break;
    }
  }

  onPopOverClicked(data) {
    if (data && data.key === 'center') {
      this.data.page !== Page.LEVEL_D && this.goToProductDetail(
        this.data.product.productId,
        this.data.product.slug,
        this.data.product.productTitle,
      );
    } else {
      const product = this.productPoiList[data.key];
      this.goToProductDetail(
        product.productId,
        product.slug,
        product.productTitle
      );
    }
  }

  onRenderMarkerComplete(event) {
    ++this.countMarker;
    event === 'center' && this.InfoWindowContentComponent && this.isMobile && this.setInfoWindowData(
      this.data.product.imageUrl,
      this.data.product.productTitle,
      this.data.product.hotelStar,
      'center',
      this.reviewRating,
      true
    );
    const allMarker = this.productPoiList && this.productPoiList.length > 0
      ? this.productPoiList.length + 2 : 2;
    this.isMobile && allMarker === this.countMarker && (this.resetCenter = true);
    this.resetCenter && this.iPhoneUpdateSizing();
    this.resetCenter && this.setActiveMarker('center');
  }

  onRenderPopOverComplete(event) {
    ++this.countPopOver;
    const allPopOver = this.productPoiList && this.productPoiList.length > 0
      ? this.productPoiList.length + 2 : 2;
    allPopOver === this.countPopOver && allPopOver === this.countMarker
      && (this.isAllPopOverComplete = this.resetCenter = true);

    this.resetCenter && this.iPhoneUpdateSizing();
  }

  sendGAMapLoaded() {
    if (!this.gaSent) {
      this.gaSent = true;
      this.googleTagManagerService.emitEvent(
        'Poi Map Search',
        'Loaded',
        this.data && this.data.product ? this.data.product.title || '' : '',
        Math.round(new Date().getTime() / 1000 - this.now)
      );
    }
  }

  goToProductDetail(id, slug, title) {
    this.removeLink();
    const url = this.productService.getProductDetailsUrl({
      id,
      slug,
      suggestCat: 'product',
      title,
      purpose: this.data.searchData.purpose,
      checkInDate: this.utilitiesService.convertDateFormat(this.data.searchData.checkInDate, 'YYYY-MM-DD', 'DD-MM-YYYY', 'en'),
      checkOutDate: this.utilitiesService.convertDateFormat(this.data.searchData.checkOutDate, 'YYYY-MM-DD', 'DD-MM-YYYY', 'en'),
      guests: this.data.searchData.guests,
      breakfast: false,
      overBudget: false,
      isReverseFormatDate: false
    });
    this.setLink(url);
  }

  setLink(url) {
    const link = document.getElementById('link-to-product-detail') as HTMLElement;
    link.setAttribute('target', '_blank');
    link.setAttribute('href', url);
    link.click();
  }

  removeLink() {
    const link = document.getElementById('link-to-product-detail') as HTMLElement;
    link.removeAttribute('target');
    link.removeAttribute('href');
  }

  resetIphoneHandler() {
    this.$mapElement && this.$mapElement.removeClass('iphone');
  }

  iPhoneUpdateSizing() {
    this.$mapElement = $('.act-map-container-inner');
    this.$infoWindowElement = $('.info-window-mobile');
    // handle for iPhone (safari and firefox) only
    let canHandle = !!platform && window.navigator.platform === 'iPhone';
    canHandle = canHandle && platform.product === 'iPhone';
    canHandle = canHandle && (platform.name === 'Safari' || platform.name === 'Firefox');
    canHandle && this.$mapElement && this.$mapElement.addClass('iphone');
    canHandle && this.$infoWindowElement && this.$infoWindowElement.addClass('iphone');
    this.sendGAMapLoaded();
  }

  setActiveMarker(active: string) {
    this.infoMarker.map((marker) => {
      marker.setActiveMarker(active === marker.key);
    });
  }

  subscribeCurrency() {
    this.currency = this.currencyService.getCurrency();
    this.currencySubscription = this.currencyService.getCurrencyObs().subscribe(currency => {
      this.currency = currency;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-map-poi/dialog-map-poi.component.ts